module.exports = __webpack_public_path__ + "media/images/vehicles/kranfahrzeug-fe7828facad98db4ca1dd4b6bc370e1c.png";